import React from 'react'
// libs
import styled from 'styled-components'
// theme
import { colors } from 'themes/index'

const Panel = styled.div<{ color: string }>`
  width: 250px;
  min-height: 48px;
  min-width: 250px;
  height: 60px;
  background-color: ${({ color }) => color};
  color: ${colors.white100};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: underline;
`

interface Props {
  name?: string
  color: string
  onClick: () => void
  children?: React.ReactNode
}

const ColorPanel: React.FC<Props> = ({ color, children, onClick, name }) => {
  return (
    <Panel data-testid={`color-${name}`} color={color} onClick={onClick}>
      {children}
    </Panel>
  )
}

export default ColorPanel
